import { FC } from 'react';
import { Colors, FInter, FlexBox } from '@brg/ui';
import styled, { useTheme } from 'styled-components';
import { useTranslation } from 'react-i18next';
import { IconCloseMob } from '../SelectGeoLocationTagsModal/SelectGeoLocationTagsModal';

/**
 * @param Модалка для несохраненных данных @Artem
 */

 export const BackLink = styled(FInter.SectionTitleDiv)`
 cursor: pointer;
 transition: all 0.2s;

 &:hover {
   opacity: 0.71;
 }
`;

const Wrapper = styled(FlexBox)`
    width: 564px;
    padding: 32px 40px 40px;
    border-radius: 8px;
    gap: 16px;
    background: ${({theme}) => theme.mainBg};
    margin-bottom: 20%;
    max-width: 564px;
    align-items: start;

    svg {
        cursor: pointer;

        path {
            transition: fill 0.2s;
        }

        &:hover {
            path: {
                fill: #151514;
                transition: fill 0.2s;
            }
        }
    }
`;

const Title = styled(FInter.SectionTitle)`
    font-family: Inter;
    font-size: 30px;
    font-style: normal;
    font-weight: 600;
    letter-spacing: -0.6px;
    line-height: 33px;
`

const Text = styled(FInter.Text)`
    font-family: Inter;
    font-size: 17px;
    font-style: normal;
    font-weight: 400;
    line-height: 22px;
    letter-spacing: -0.34px;
    max-width: 450px;
`;

const SmallText = styled.div`
    font-size: 17px;
    line-height: 22px;
    font-weight: 400;
    color: ${Colors.galBlack47};
`;

export const LockDataModal: FC<{
    editorName: string,
    editorTime: string,
    onClose?: () => void,
    }> = 
    ({onClose, editorName, editorTime  }) => {
    const { t } = useTranslation();
    const theme = useTheme();

    return <Wrapper className="lockdata_wrapper" direction={'row'} width={'100%'} justify='left' align='center'>
               <FlexBox direction='column' directionMobile='column' gy={16} gyMobile={16}>
                <Title color={theme.not_saved_modal.title}>
                    {t('lock_modal.title')}
                    </Title>
                    <Text color={'#151514'}>
                        {t('lock_modal.subtitle')}
                    </Text>
                    <SmallText>{t('lock_modal.editorName', { editorName })}</SmallText>
                    <SmallText>{t('lock_modal.editorTime', { editorTime })}</SmallText>
               </FlexBox>
               <FlexBox>
                    <IconCloseMob onClick={onClose} />
               </FlexBox>
        </Wrapper>

};
import { FC } from 'react';
import { Colors, FInter, FlexBox } from '@brg/ui';
import styled, { useTheme } from 'styled-components';
import { useTranslation } from 'react-i18next';
import { IconCloseMob } from '../SelectGeoLocationTagsModal/SelectGeoLocationTagsModal';

/**
 * @param Модалка для несохраненных данных @Artem
 */

 export const BackLink = styled(FInter.SectionTitleDiv)`
 cursor: pointer;
 transition: all 0.2s;

 &:hover {
   opacity: 0.71;
 }
`;

const Wrapper = styled(FlexBox)`
    width: 564px;
    padding: 32px 40px 40px;
    border-radius: 8px;
    gap: 16px;
    background: ${({theme}) => theme.mainBg};
    margin-bottom: 20%;
    max-width: 564px;
    align-items: start;

    svg {
        cursor: pointer;

        path {
            transition: fill 0.2s;
        }

        &:hover {
            path: {
                fill: #151514;
                transition: fill 0.2s;
            }
        }
    }
`;

const Title = styled(FInter.SectionTitle)`
    font-family: Inter;
    font-size: 30px;
    font-style: normal;
    font-weight: 600;
    letter-spacing: -0.6px;
    line-height: 33px;
`

const Text = styled(FInter.Text)`
    font-family: Inter;
    font-size: 17px;
    font-style: normal;
    font-weight: 400;
    line-height: 22px;
    letter-spacing: -0.34px;
    max-width: 450px;
`;

const SmallText = styled.div`
    font-size: 17px;
    line-height: 22px;
    font-weight: 400;
    color: ${Colors.galBlack47};
`;

export const LockDataModal: FC<{
    editorName: string,
    editorTime: string,
    onClose?: () => void,
    }> = 
    ({onClose, editorName, editorTime  }) => {
    const { t } = useTranslation();
    const theme = useTheme();

    return <Wrapper className="lockdata_wrapper" direction={'row'} width={'100%'} justify='left' align='center'>
               <FlexBox direction='column' directionMobile='column' gy={16} gyMobile={16}>
                <Title color={theme.not_saved_modal.title}>
                    {t('lock_modal.title')}
                    </Title>
                    <Text color={'#151514'}>
                        {t('lock_modal.subtitle')}
                    </Text>
                    <SmallText>{t('lock_modal.editorName', { editorName })}</SmallText>
                    <SmallText>{t('lock_modal.editorTime', { editorTime })}</SmallText>
               </FlexBox>
               <FlexBox>
                    <IconCloseMob onClick={onClose} />
               </FlexBox>
        </Wrapper>

};
